import { poll } from '@tunein/web-utils';
export class NowPlayingPoller {
    #api;
    #stop;
    #options;
    #token;
    #isRunning = false;
    constructor(api) {
        this.#api = api;
    }
    #pollNowPlaying = async () => {
        const nowPlaying = (await this.fetchOnce());
        if (!this.#isRunning) {
            return;
        }
        try {
            this.#options?.onMetadata?.(nowPlaying);
        }
        catch {
            // noop
        }
        return nowPlaying?.ttl;
    };
    get isRunning() {
        return this.#isRunning;
    }
    async fetchOnce(options) {
        if (options) {
            this.#options = options;
        }
        const { guideId, itemToken } = this.#options || {};
        try {
            const nowPlaying = await this.#api.streams.getNowPlaying({
                guideId,
                token: this.#token,
                itemToken,
            });
            this.#token = nowPlaying?.token || this.#token;
            return nowPlaying;
        }
        catch {
            // noop
        }
    }
    start(options) {
        this.stop();
        this.#options = options;
        this.#stop = poll(this.#pollNowPlaying, options.initialDelay);
        this.#isRunning = true;
    }
    stop() {
        this.#stop?.();
        this.#isRunning = false;
        this.#token = undefined;
    }
}
